import { render, staticRenderFns } from "./BrokerList.vue?vue&type=template&id=0b924eba&"
import script from "./BrokerList.vue?vue&type=script&lang=js&"
export * from "./BrokerList.vue?vue&type=script&lang=js&"
import style0 from "./BrokerList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BrokerList.vue"
export default component.exports